<template>
  <div>
    <header>
      <div class="header">
        <div class="head_icon_box pc">
          <div class="container">
            <div class="phone_box">
              <img
                src="../assets/images/icon/phone.png"
                alt=""
                class="icon_phone"
              />
              <a href="tel:+86 22 84776558"><span>+86 22 84776558</span></a>
            </div>
            <div class="email_box">
              <img
                src="../assets/images/icon/email.png"
                alt=""
                class="icon_email"
              />
              <a href="mailto:HS@Hisantech.com"
                ><span>HS@Hisantech.com</span></a
              >
            </div>
            <ul class="lx_icon_box">
              <!-- <li>
                <a href="">
                  <img
                    src="../assets/images/icon/facebook.png"
                    alt=""
                    srcset=""
                    class="icon1"
                  />
                  <img
                    src="../assets/images/icon/facebook1.png"
                    alt=""
                    srcset=""
                    class="icon1"
                  />
                </a>
              </li>
              <li>
                <a href="">
                  <img
                    src="../assets/images/icon/whatsapp.png"
                    alt=""
                    srcset=""
                    class="icon2"
                  />
                  <img
                    src="../assets/images/icon/whatsapp1.png"
                    alt=""
                    srcset=""
                    class="icon2"
                  />
                </a>
              </li> -->
              <li>
                <a
                  href="https://www.linkedin.com/company/hisan-tianjin-co-ltd/"
                >
                  <img
                    src="../assets/images/icon/in.png"
                    alt=""
                    srcset=""
                    class="icon3"
                  />
                  <img
                    src="../assets/images/icon/in1.png"
                    alt=""
                    srcset=""
                    class="icon3"
                  />
                </a>
              </li>
              <li>
                <a href="https://t.me/+8615302024577">
                  <img
                    src="../assets/images/icon/telegram-plane.png"
                    alt=""
                    srcset=""
                    class="icon4"
                  />
                  <img
                    src="../assets/images/icon/telegram-plane1.png"
                    alt=""
                    srcset=""
                    class="icon4"
                  />
                </a>
              </li>
              <!-- <li>
                <a href="">
                  <img
                    src="../assets/images/icon/skype.png"
                    alt=""
                    srcset=""
                    class="icon5"
                  />
                  <img
                    src="../assets/images/icon/skype1.png"
                    alt=""
                    srcset=""
                    class="icon5"
                  />
                </a>
              </li> -->
              <li>
                <a href="https://vk.com/id851824022">
                  <img
                    src="../assets/images/icon/vk.png"
                    alt=""
                    srcset=""
                    class="icon6"
                  />
                  <img
                    src="../assets/images/icon/vk1.png"
                    alt=""
                    srcset=""
                    class="icon6"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="container_box">
          <div class="container">
            <div class="header_left ">
              <router-link to="/"
                ><img src="../assets/images/header/logo1.png" alt="" class=""
              /></router-link>
            </div>
            <div class="header_right_mobile">
              <router-link to="/Contact-us" class="contant mobile">
                <div class="Contact">
                  Contact Us
                  <img src="../assets/images/icon/fei.png" alt="" class="fei" />
                </div>
              </router-link>
              <div class="menu wap" @click="handShowMenuList">
                <img src="../assets/images/m/menu.png" alt="" class="" />
              </div>
            </div>
            <div class="header_right pc">
              <ul class="head_menu">
                <li>
                  <a href="javascript:;" class="menu_title">About Us</a>
                  <div class="menu_list">
                    <div class="menu_list_con">
                      <p>
                        <router-link to="/Who-we-are">Who we are </router-link>
                      </p>
                      <p>
                        <router-link to="/Our-responsibility"
                          >Our Responsibility</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/Why-choose-us"
                          >Why Choose us</router-link
                        >
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;" class="menu_title">Company Strength</a>
                  <div class="menu_list">
                    <div class="menu_list_con">
                      <p>
                        <router-link to="/Production-capacity"
                          >Production capacity</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/Research-ability"
                          >Research ability</router-link
                        >
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;" class="menu_title">Products</a>
                  <div class="menu_list">
                    <div class="menu_list_con">
                      <p>
                        <router-link to="/Welding-wire"
                          >Welding wire</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/cco">CCO plate</router-link>
                      </p>
                      <!-- <p ><router-link to="/nihard">High Chromium White Cast Iron</router-link></p>
											<p ><router-link to="/wear">Wear resistant ceramics</router-link></p>
											 -->
                      <p>
                        <router-link to="/product/Overlay-Wear-Pipe"
                          >Overlay Wear Pipe</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/Wear-parts">Wear parts</router-link>
                      </p>
                      <!-- 											<p ><router-link to="/detail?id=24">AR steel plate </router-link></p> -->
                    </div>
                  </div>
                </li>

                <li>
                  <a href="javascript:;" class="menu_title">Applications</a>
                  <div class="menu_list t_right">
                    <div class="menu_list_con">
                      <p>
                        <router-link to="/appliction/mining"
                          >Mining</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/appliction/cement-plant"
                          >Cement Plant</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/appliction/power-plant"
                          >Power Plant</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/appliction/port">Port</router-link>
                      </p>
                      <p>
                        <router-link to="/appliction/steel-mill"
                          >Steel Mill</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/appliction/bulk-material-handling"
                          >Bulk Material Handling</router-link
                        >
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="javascript:;" class="menu_title">News</a>
                  <div class="menu_list t_right">
                    <div class="menu_list_con">
                      <p>
                        <router-link to="/Company-news"
                          >Company News</router-link
                        >
                      </p>
                      <p>
                        <router-link to="/Industry-news"
                          >Industry News</router-link
                        >
                      </p>
                    </div>
                  </div>
                </li>
                <li>
                  <router-link to="/Contact-us" class="contant">
                    <div class="Contact">
                      Contact Us
                      <img
                        src="../assets/images/icon/fei.png"
                        alt=""
                        class="fei"
                      />
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="lx_icon_box2 wap">
        <ul class="lx_icon_box pc">
          <li>
            <a href="tel:+86 22 84776558">
              <img
                src="../assets/images/icon/phone.png"
                alt=""
                class="icon_phone"
              />
              <img
                src="../assets/images/icon/phone.png"
                alt=""
                class="icon_phone"
              />
            </a>
          </li>
          <li>
            <a href="mailto:HS@Hisantech.com">
              <img
                src="../assets/images/icon/email.png"
                alt=""
                class="icon_email"
              />
              <img
                src="../assets/images/icon/email.png"
                alt=""
                class="icon_email"
              />
            </a>
          </li>
          <li>
            <a href="">
              <img
                src="../assets/images/icon/facebook.png"
                alt=""
                srcset=""
                class="icon1"
              />
              <img
                src="../assets/images/icon/facebook1.png"
                alt=""
                srcset=""
                class="icon1"
              />
            </a>
          </li>
          <li>
            <a href="">
              <img
                src="../assets/images/icon/whatsapp.png"
                alt=""
                srcset=""
                class="icon2"
              />
              <img
                src="../assets/images/icon/whatsapp1.png"
                alt=""
                srcset=""
                class="icon2"
              />
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/hisan-tianjin-co-ltd/">
              <img
                src="../assets/images/icon/in.png"
                alt=""
                srcset=""
                class="icon3"
              />
              <img
                src="../assets/images/icon/in1.png"
                alt=""
                srcset=""
                class="icon3"
              />
            </a>
          </li>
          <li>
            <a href="https://t.me/+8615302024577">
              <img
                src="../assets/images/icon/telegram-plane.png"
                alt=""
                srcset=""
                class="icon4"
              />
              <img
                src="../assets/images/icon/telegram-plane1.png"
                alt=""
                srcset=""
                class="icon4"
              />
            </a>
          </li>
          <li>
            <a href="">
              <img
                src="../assets/images/icon/skype.png"
                alt=""
                srcset=""
                class="icon5"
              />
              <img
                src="../assets/images/icon/skype1.png"
                alt=""
                srcset=""
                class="icon5"
              />
            </a>
          </li>
          <li>
            <a href="https://vk.com/id851824022">
              <img
                src="../assets/images/icon/vk.png"
                alt=""
                srcset=""
                class="icon6"
              />
              <img
                src="../assets/images/icon/vk1.png"
                alt=""
                srcset=""
                class="icon6"
              />
            </a>
          </li>
        </ul>
        <ul class="lx_icon_box lx_icon_box_mobile">
          <li>
            <a href="tel:+86 22 84776558">
              <img
                src="../assets/images/icon/phone_mobile.png"
                alt=""
                class="icon_phone"
              />
              <img
                src="../assets/images/icon/phone.png"
                alt=""
                class="icon_phone"
              />
            </a>
          </li>
          <li>
            <a href="mailto:HS@Hisantech.com">
              <img
                src="../assets/images/icon/email_mobile.png"
                alt=""
                class="icon_email"
              />
              <img
                src="../assets/images/icon/email.png"
                alt=""
                class="icon_email"
              />
            </a>
          </li>
          <li>
            <a href="">
              <img
                src="../assets/images/icon/facebook_mobile.png"
                alt=""
                srcset=""
                class="icon1"
              />
              <img
                src="../assets/images/icon/facebook1.png"
                alt=""
                srcset=""
                class="icon1"
              />
            </a>
          </li>
          <li>
            <a href="">
              <img
                src="../assets/images/icon/share_mobile.png"
                alt=""
                srcset=""
                class="icon2"
              />
              <img
                src="../assets/images/icon/whatsapp1.png"
                alt=""
                srcset=""
                class="icon2"
              />
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/hisan-tianjin-co-ltd/">
              <img
                src="../assets/images/icon/ins_mobile.png"
                alt=""
                srcset=""
                class="icon3"
              />
              <img
                src="../assets/images/icon/in1.png"
                alt=""
                srcset=""
                class="icon3"
              />
            </a>
          </li>
          <li>
            <a href="https://t.me/+8615302024577">
              <img
                src="../assets/images/icon/telegram_mobile.png"
                alt=""
                srcset=""
                class="icon4"
              />
              <img
                src="../assets/images/icon/telegram-plane1.png"
                alt=""
                srcset=""
                class="icon4"
              />
            </a>
          </li>
          <li>
            <a href="">
              <img
                src="../assets/images/icon/skype_mobile.png"
                alt=""
                srcset=""
                class="icon5"
              />
              <img
                src="../assets/images/icon/skype1.png"
                alt=""
                srcset=""
                class="icon5"
              />
            </a>
          </li>
          <li>
            <a href="https://vk.com/id851824022">
              <img
                src="../assets/images/icon/vk_mobile.png"
                alt=""
                srcset=""
                class="icon6"
              />
              <img
                src="../assets/images/icon/vk1.png"
                alt=""
                srcset=""
                class="icon6"
              />
            </a>
          </li>
        </ul>
      </div>
    </header>
    <!-- 菜单弹框` -->
    <!--  -->
    <!--  -->
    <div class="menu-popup" v-show="show" @click="handShowMenuList">
      <div class="menu-box">
        <div class="menu-group">
          <ul>
            <li
              class="menu-item b-b"
              v-for="(menu, index) in menuList"
              :key="index"
              @click.stop="openSubMenu(index)"
            >
              <div>
                {{ menu.name }}
                <img
                  src="@/assets/images/header/arrow_right.png"
                  alt=""
                  class="arrow_right"
                  v-if="activeIndex !== index"
                />
                <img
                  src="@/assets/images/header/arrow_down.png"
                  alt=""
                  class="arrow_right"
                  v-else
                />
              </div>
              <ul class="sub-menu-group" v-show="activeIndex === index">
                <li
                  class="menu-sub-item"
                  v-for="(subMenu, i) in menu.children"
                  :key="i"
                >
                  <div
                    :to="subMenu.path"
                    class="link"
                    @click="goPath(subMenu.path, i)"
                  >
                    {{ subMenu.name }}
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      activeIndex: -1,
      subActiveIndex: -1,
      menuList: [
        {
          name: "close",
          children: [],
        },
        {
          name: "About us",
          children: [
            {
              path: "/Who-we-are",
              name: "Who we are",
            },
            {
              path: "/Our-responsibility",
              name: "Our Responsibility",
            },
            {
              path: "/Why-choose-us",
              name: "Why Choose us",
            },
          ],
        },
        {
          name: "Company Strength",
          children: [
            {
              path: "/Production-capacity",
              name: "Production capacity",
            },
            {
              path: "/Research-ability",
              name: "Research ability",
            },
          ],
        },
        {
          name: "Products",
          children: [
            {
              path: "/Welding-wire",
              name: "Welding wire",
            },
            {
              path: "/cco",
              name: "CCO plate",
            },
            {
              path: "/product/Overlay-Wear-Pipe",
              name: "Overlay Wear Pipe",
            },
            {
              path: "/Wear-parts",
              name: "Wear parts",
            },
          ],
        },
        {
          name: "Applications",
          children: [
            {
              path: "/appliction/mining",
              name: "Mining",
            },
            {
              path: "/appliction/cement-plant",
              name: "Cement Plant",
            },
            {
              path: "/appliction/power-plant",
              name: "Power Plant",
            },
            {
              path: "/appliction/port",
              name: "Port",
            },
            {
              path: "/appliction/steel-mill",
              name: "Steel Mill",
            },
            {
              path: "/appliction/bulk-material-handling",
              name: "Bulk Material Handling",
            },
          ],
        },
        {
          name: "News",
          children: [
            {
              path: "/Company-news",
              name: "Company News",
            },
            {
              path: "/Industry-news",
              name: "Industry News",
            },
          ],
        },
      ],
    };
  },
  methods: {
    handShowMenuList() {
      console.log("click");
      this.show = !this.show;
    },
    openSubMenu(index) {
      console.log(index, "ii");
      if (index === 0) {
        this.handShowMenuList();
        return;
      }
      if (this.activeIndex === index) {
        this.activeIndex = -1;
      } else {
        this.activeIndex = index;
      }
    },
    goPath(url, index) {
      this.$router.push(url);
      this.subActiveIndex = index;
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
.menu-popup {
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
  .menu-box {
    margin-left: 40%;
    width: 60%;
    height: 100%;
    background-color: #9f2e2c;
    .menu-item {
      padding: 12px;
      text-align: right;
      color: #fff;
      font-size: 18px;
      .menu-sub-item {
        padding: 10px;
        text-align: right;
        color: #fff;
        font-size: 14px;
      }
    }
  }
  .arrow_right {
    width: 16px;
    height: 16x;
  }
  .b-b {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }
  .link {
    color: #fff;
    &.active-link {
      color: #666;
    }
  }
}
.mobile {
  &.contant {
    text-align: center;
    color: #fff;
    background: #ad1f24;
    border-radius: 3px;
    font-size: 10px;
    padding: 3px;
    display: flex;
    align-items: center;
    margin-right: 12px;
    margin-top: 4px;
    img {
      width: 14px;
      // height: 10px;
    }
  }
}
</style>
